import React, { useState, useEffect } from "react";
import { Row, Col, Container, Form, Button, Image, Dropdown, Card, InputGroup } from "react-bootstrap";
import { Link, useNavigate, useLocation } from "react-router-dom";
import "./Style.css";
import { Swiper, SwiperSlide } from "swiper/react";
import SwiperCore, { Navigation, Autoplay } from "swiper";
import "swiper/swiper-bundle.min.css";
import axios from "axios";
import toast, { Toaster } from "react-hot-toast";
import { setAuthToken, setAuthData } from "../../../utils/auth";
import { useGoogleLogin } from "@react-oauth/google";
import qs from "qs";
import Footer from "../Footer/Footer";
import { useProjectName } from "../../../Context/ProjectNameContext";
import { useTranslation } from "react-i18next";
import { CircularProgress } from "@mui/material";
import ReCAPTCHA from "react-google-recaptcha";
import PhoneInput from "react-phone-input-2";
import "react-phone-input-2/lib/style.css";
import { getCookie } from "cookies-next";
import Cookies from 'js-cookie';
import { IoEyeOutline, IoEyeOffOutline } from "react-icons/io5";
import { FcGoogle } from "react-icons/fc";
import { SiLinkedin } from "react-icons/si";
import { DiApple } from "react-icons/di";

// install Swiper modules
SwiperCore.use([Navigation, Autoplay]);

const SignIn = () => {
  let navigate = useNavigate();
  const projectName = useProjectName();
  const [otpMode, setOtpMode] = useState(false);
  const [otp, setOtp] = useState("");
  const [loadingFull, setLoadingFull] = useState(false);
  const [rememberMe, setRememberMe] = useState(true);
  const [logo, setLogo] = useState("");
  const [useEmail, setUseEmail] = useState(true);
  const [formData, setFormData] = useState({
    email: "",
    mobile: "",
    password: "",
  });
  const [captchaValue, setCaptchaValue] = useState(null);
  const [showLoginPassword, setShowLoginPassword] = useState(false);

  const [isDropdownVisible, setDropdownVisible] = useState(false);

  const toggleDropdownLang = () => setDropdownVisible(!isDropdownVisible);
  const closeDropdownLang = () => setDropdownVisible(false);

  const changeLanguage = (lng) => {
    localStorage.setItem("i18nextLng", lng)
    Cookies.set("language", lng, { expires: 30 });
    i18n.changeLanguage(lng);
    closeDropdownLang();
  };
  const handleCaptchaChange = (value) => {
    setCaptchaValue(value);
  };
  const handleChange = (event) => {
    const { id, value } = event.target;
    setFormData((prevFormData) => ({
      ...prevFormData,
      [id]: value,
    }));
  };

  const handlePhoneChange = (value) => {
    setFormData((prev) => ({
      ...prev,
      mobile: value,
    }));
  };

  const location = useLocation(); // Get the current location

  const [userDetails, setUserDetails] = useState(null); // State for storing user details

  // Function to initiate LinkedIn login
  const linkedInLogin = () => {
    window.location.href =
      "https://www.linkedin.com/oauth/v2/authorization?response_type=code&client_id=" +
      process.env.REACT_APP_LINKEDIN_CLIENT_ID +
      "&redirect_uri=" +
      process.env.REACT_APP_LINKEDIN_REDIRECT_URI +
      "&scope=openid%20profile%20email%20w_member_social";
  };

  const handleMicrosoftLogin = () => {
    window.location.href = `${process.env.REACT_APP_URL}/api/auth/microsoft/login`;
  };
  const handleAppleLogin = () => {
    window.location.href = `${process.env.REACT_APP_URL}/api/auth/apple/login`;
  };

  const handleGoogleLogin = useGoogleLogin({
    flow: "auth-code",
    onSuccess: async (codeResponse) => {
      //   console.log(codeResponse);
      try {
        const body = qs.stringify({
          client_id: process.env.REACT_APP_GOOGLE_CLIENT_ID,
          client_secret: process.env.REACT_APP_GOOGLE_CLIENT_SECRET,
          code: codeResponse.code,
          grant_type: "authorization_code",
          redirect_uri: window.location.origin,
        });

        const config = {
          method: "post",
          maxBodyLength: Infinity,
          url: "https://oauth2.googleapis.com/token",
          headers: {
            "Content-Type": "application/x-www-form-urlencoded",
          },
          data: body,
        };

        const googleTokenResponse = await axios.request(config);

        // Extract the access token from the Google response
        const googleAccessToken = googleTokenResponse.data.access_token;

        //  console.log("Google Access Token:", googleAccessToken);

        // Pass the required data to your backend for social login
        const backendPayload = {
          accessToken: googleAccessToken, // Ensure this is included
          service: "google", // Ensure this field is always included
        };

        const response = await axios.post(
          `${process.env.REACT_APP_URL}/api/auth/social-login`,
          backendPayload, // Directly pass the payload object
          {
            headers: {
              "Content-Type": "application/json",
            },
          }
        );

        const { data } = response;
        if (!data) return;

        // Set auth data in the same way as in handleLogin
        const { token, userDetails } = data.data;
        //  setAuthToken(token);
        //  setAuthData( userDetails);
        const storageType = rememberMe ? "local" : "session";
        setAuthToken(token, storageType);
        setAuthData(userDetails, storageType);

        toast.success(data.message);
        navigate("/");
      } catch (e) {
        console.log(e);
        toast.error("Something went wrong with Google login");
      }
    },
    onError: (error) => console.log("Login Failed:", error),
  });

  const handleLogin = async () => {
    if ((!formData.email && useEmail) || (!formData.mobile && !useEmail)) {
      toast.error("Please provide either Email or Mobile number.");
      return;
    }
    if ((!formData.password)) {
      toast.error("Password is required.");
      return;
    }
    if (!captchaValue) {
      toast.error("Please complete the reCAPTCHA before logging in.");
      return;
    }
    try {
      setLoadingFull(true);
      const response = await axios.post(
        `${process.env.REACT_APP_URL}/api/auth/sign-in`,
        {
          // username: formData.username,
          username: useEmail ? formData.email : formData.mobile,
          password: formData.password,
        },
        {
          headers: {
            "Content-type": "application/json",
          },
        }
      );
      // console.log("Login Successfully", response.data);
      // setOtpMode(true);
      // fetchUserData(response.data.data.token);
      // toast.success(response.data.message)
      // navigate("/");

      const { data } = response;
      const { userDetails, token } = data?.data;

      if (!userDetails?.enableTwoFactorAuthentication) {
        const storageType = rememberMe ? "local" : "session";
        setAuthToken(token, storageType);
        setAuthData(userDetails, storageType);
        fetchUserData(token);

        toast.success(data?.message || "Login Successful");
        navigate("/");
      } else {
        setOtpMode(true);
        toast.success("Enter OTP to verify.");
      }
    } catch (error) {
      if (
        error.response &&
        error.response.data &&
        error.response.data &&
        error.response.data.message
      ) {
        toast.error(error.response.data.message);
      } else {
        toast.error("An error occurred while signing in.");
      }
      console.log("Error in Sign in", error);
    } finally {
      setLoadingFull(false);
    }
  };

  const handleOtpChange = (event) => {
    setOtp(event.target.value);
  };

  const handleVerifyOtp = async () => {
    if (!captchaValue) {
      toast.error("Please complete the reCAPTCHA before logging in.");
      return;
    }
    try {
      setLoadingFull(true);
      // const isEmail = /^[^\s@]+@[^\s@]+\.[^\s@]+$/.test(formData.username);

      const payload = {
        OTP: otp,
        verificationFor: "login",
        ...(useEmail ? { email: formData.email } : { mobile: formData.mobile }),
      };

      const response = await axios.post(
        `${process.env.REACT_APP_URL}/api/auth/verify-OTP-login`,
        //  `${process.env.REACT_APP_URL}/api/auth/verifyOTP`,
        payload,
        {
          headers: {
            "Content-Type": "application/json",
          },
        }
      );
      setCaptchaValue(null);
      setOtpMode(false);
      setOtp("");
      setFormData({
        username: "",
        password: "",
      });
      const token = response.data.data.token;
      const storageType = rememberMe ? "local" : "session";
      setAuthToken(token, storageType);
      setAuthData(response.data.data.userDetails, storageType);
      fetchUserData(token);
      toast.success(response.data.message || "OTP verified successfully");
      navigate("/");
    } catch (error) {
      const errorMsg = error.response?.data?.message || "Error verifying OTP.";
      toast.error(errorMsg);
    } finally {
      setLoadingFull(false);
    }
  };

  const fetchUserData = async (token) => {
    try {
      const response = await axios.get(
        `${process.env.REACT_APP_URL}/api/user`,
        {
          headers: {
            Authorization: `Bearer ${token}`,
          },
        }
      );
      //   console.log("user details", response.data.data);
      // localStorage.setItem('profileImage',response?.data?.data?.profileImageLink || 'https://diridob2c.s3.ap-south-1.amazonaws.com/dirido_B2c/b8e5cb20-72d9-4d79-93f4-6da674daa7e5_profile.png');
    } catch (error) {
      console.error("Failed Fetching Details", error);
    }
  };
  const { t, i18n } = useTranslation();


  const handleLogo = async () => {
    try {
      const response = await axios.get(
        `${process.env.REACT_APP_URL}/api/default-setting/footer?status=true`
      );
      const logoLink = response?.data?.data?.enableMaintenanceMode?.logoLink;
      setLogo(logoLink || "");
    } catch (error) {
      console.log("Error fetching logo", error);
    }
  };
  useEffect(() => {
    handleLogo();
  }, []);

  // useEffect(() => {
  //   const checkLanguage = async () => {
  //     // Check for saved language preference
  //     const savedLanguage = getCookie('i18next');

  //     if (savedLanguage && i18n.language !== savedLanguage) {
  //       await i18n.changeLanguage(savedLanguage);
  //     }
  //   };

  //   checkLanguage();
  // }, [i18n]);

  return (
    <>
      <Toaster position="top-right" reverseOrder={false} />
      {loadingFull && (
        <div style={styles.loaderOverlay}>
          <CircularProgress style={{ color: "white" }} />
        </div>
      )}
      <div>
        <section className="sign-in-page">
          <Container
            className="p-0"
            style={{
              alignItems: "center",
              display: "flex",
              flexDirection: "column",
              justifyContent: "center",
            }}
          >
            {logo && (
              <div
                style={{
                  fontSize: "30px",
                  marginTop: "10px",
                  letterSpacing: "4px",
                  color: "white",
                  fontWeight: "600",
                  textTransform: "uppercase",
                }}
                className={window.innerWidth <= 768 ? "mobile-margin-top" : ""}
              >
                {/* {projectName}  */}
                <img src={logo} alt="logo" style={{ width: "120px" }} />
              </div>
            )}

            <Row
              className="no-gutters"
              style={{
                borderRadius: "10px",
                height: "auto",
                // overflow: "auto",
                justifyContent: "center",
                display: "flex",
                margin: "20px",
              }}
            >
              <Col
                md="12"
                className="bg-white pb-2"
                style={{ height: "auto", width: "400px", borderRadius: "10px", }}
              >
                <div className="sign-in-from" style={{ paddingInline: "20px" }}>
                  <div className="d-flex justify-content-between ">
                    <div style={{ fontSize: "30px", fontWeight: "600" }} className="mb-0">{t("sign_in_heading")}</div>
                    <Dropdown
                      // as="li"
                      className="nav-item"
                      style={{ alignContent: "center" }}
                      show={isDropdownVisible}
                    >
                      <Dropdown.Toggle
                        href="#"
                        as="div"
                        onClick={toggleDropdownLang}
                        className="d-flex align-items-center text-primary position-relative"
                        style={{ cursor: "pointer" }}
                      >
                        <i
                          className="material-symbols-outlined text-primary"
                          title="Language"
                          style={{ fontSize: "24px", lineHeight: "1" }}
                        >
                          language
                        </i>
                        <span className="mobile-text d-none ms-3">
                          Language
                        </span>
                      </Dropdown.Toggle>

                      <Dropdown.Menu className="sub-drop">
                        <Card
                          className="shadow-none mb-3 m-0"
                          style={{ maxHeight: "40vh" }}
                        >
                          <Card.Header className="d-flex justify-content-between bg-primary">
                            <div className="header-title bg-primary">
                              <h5 className="mb-0 text-white">Language</h5>
                            </div>
                            <div
                              className="text-white d-flex align-items-center justify-content-center"
                              style={{ width: "40px", height: "40px" }}
                              onClick={closeDropdownLang}
                            >
                              <span className="material-symbols-outlined">
                                close
                              </span>
                            </div>
                          </Card.Header>

                          <Card.Body
                            className="p-5 mb-3 "
                            style={{ maxHeight: "40vh", overflowY: "auto" }}
                          >
                            <Link
                              to="#"
                              className="iq-sub-card"
                              onClick={() => changeLanguage("en")}
                            >
                              <div className="d-flex align-items-center">
                                <div className="ms-3">
                                  <h6 className="mb-0 ">English</h6>
                                </div>
                              </div>
                            </Link>
                            <Link
                              to="#"
                              className="iq-sub-card"
                              onClick={() => changeLanguage("fr")}
                            >
                              <div className="d-flex align-items-center">
                                <div className="ms-3">
                                  <h6 className="mb-0 ">Français</h6>
                                </div>
                              </div>
                            </Link>
                            <Link
                              to="#"
                              className="iq-sub-card"
                              onClick={() => changeLanguage("de")}
                            >
                              <div className="d-flex align-items-center">
                                <div className="ms-3">
                                  <h6 className="mb-0 ">Deutsch</h6>
                                </div>
                              </div>
                            </Link>
                            <Link
                              to="#"
                              className="iq-sub-card"
                              onClick={() => changeLanguage("it")}
                            >
                              <div className="d-flex align-items-center">
                                <div className="ms-3">
                                  <h6 className="mb-0 ">Italiano</h6>
                                </div>
                              </div>
                            </Link>
                            <Link
                              to="#"
                              className="iq-sub-card"
                              onClick={() => changeLanguage("pt")}
                            >
                              <div className="d-flex align-items-center">
                                <div className="ms-3">
                                  <h6 className="mb-0 ">Português</h6>
                                </div>
                              </div>
                            </Link>
                            <Link
                              to="#"
                              className="iq-sub-card"
                              onClick={() => changeLanguage("ar")}
                            >
                              <div className="d-flex align-items-center">
                                <div className="ms-3">
                                  <h6 className="mb-0 ">العربية</h6>
                                </div>
                              </div>
                            </Link>
                            <Link
                              to="#"
                              className="iq-sub-card"
                              onClick={() => changeLanguage("tr")}
                            >
                              <div className="d-flex align-items-center">
                                <div className="ms-3">
                                  <h6 className="mb-0 ">Türkçe</h6>
                                </div>
                              </div>
                            </Link>
                            <Link
                              to="#"
                              className="iq-sub-card"
                              onClick={() => changeLanguage("ru")}
                            >
                              <div className="d-flex align-items-center">
                                <div className="ms-3">
                                  <h6 className="mb-0 ">Русский</h6>
                                </div>
                              </div>
                            </Link>
                            <Link
                              to="#"
                              className="iq-sub-card"
                              onClick={() => changeLanguage("hi")}
                            >
                              <div className="d-flex align-items-center">
                                <div className="ms-3">
                                  <h6 className="mb-0 ">हिन्दी</h6>
                                </div>
                              </div>
                            </Link>
                            <Link
                              to="#"
                              className="iq-sub-card"
                              onClick={() => changeLanguage("ja")}
                            >
                              <div className="d-flex align-items-center">
                                <div className="ms-3">
                                  <h6 className="mb-0 ">日本語</h6>
                                </div>
                              </div>
                            </Link>
                            <Link
                              to="#"
                              className="iq-sub-card"
                              onClick={() => changeLanguage("ko")}
                            >
                              <div className="d-flex align-items-center">
                                <div className="ms-3">
                                  <h6 className="mb-0 ">한국어</h6>
                                </div>
                              </div>
                            </Link>
                            <Link
                              to="#"
                              className="iq-sub-card"
                              onClick={() => changeLanguage("nl")}
                            >
                              <div className="d-flex align-items-center">
                                <div className="ms-3">
                                  <h6 className="mb-0 ">Nederlands</h6>
                                </div>
                              </div>
                            </Link>
                            <Link
                              to="#"
                              className="iq-sub-card"
                              onClick={() => changeLanguage("el")}
                            >
                              <div className="d-flex align-items-center">
                                <div className="ms-3">
                                  <h6 className="mb-0 ">Ελληνικά</h6>
                                </div>
                              </div>
                            </Link>
                            <Link
                              to="#"
                              className="iq-sub-card"
                              onClick={() => changeLanguage("th")}
                            >
                              <div className="d-flex align-items-center">
                                <div className="ms-3">
                                  <h6 className="mb-0 ">ไทย</h6>
                                </div>
                              </div>
                            </Link>
                            <Link
                              to="#"
                              className="iq-sub-card"
                              onClick={() => changeLanguage("vi")}
                            >
                              <div className="d-flex align-items-center">
                                <div className="ms-3">
                                  <h6 className="mb-0 ">Tiếng Việt</h6>
                                </div>
                              </div>
                            </Link>
                            <Link
                              to="#"
                              className="iq-sub-card"
                              onClick={() => changeLanguage("uk")}
                            >
                              <div className="d-flex align-items-center">
                                <div className="ms-3">
                                  <h6 className="mb-0 ">Українська</h6>
                                </div>
                              </div>
                            </Link>
                            <Link
                              to="#"
                              className="iq-sub-card"
                              onClick={() => changeLanguage("ro")}
                            >
                              <div className="d-flex align-items-center">
                                <div className="ms-3">
                                  <h6 className="mb-0 ">Română</h6>
                                </div>
                              </div>
                            </Link>
                            <Link
                              to="#"
                              className="iq-sub-card"
                              onClick={() => changeLanguage("armenian")}
                            >
                              <div className="d-flex align-items-center">
                                <div className="ms-3">
                                  <h6 className="mb-0 ">Հայերեն</h6>
                                </div>
                              </div>
                            </Link>
                            <Link
                              to="#"
                              className="iq-sub-card"
                              onClick={() => changeLanguage("chinese")}
                            >
                              <div className="d-flex align-items-center">
                                <div className="ms-3">
                                  <h6 className="mb-0 ">中文</h6>
                                </div>
                              </div>
                            </Link>
                            <Link
                              to="#"
                              className="iq-sub-card"
                              onClick={() => changeLanguage("mandarin")}
                            >
                              <div className="d-flex align-items-center">
                                <div className="ms-3">
                                  <h6 className="mb-0 ">普通话</h6>
                                </div>
                              </div>
                            </Link>
                            <Link
                              to="#"
                              className="iq-sub-card"
                              onClick={() => changeLanguage("urdu")}
                            >
                              <div className="d-flex align-items-center">
                                <div className="ms-3">
                                  <h6 className="mb-0 ">اردو</h6>
                                </div>
                              </div>
                            </Link>
                            <Link
                              to="#"
                              className="iq-sub-card"
                              onClick={() => changeLanguage("es")}
                            >
                              <div className="d-flex align-items-center">
                                <div className="ms-3">
                                  <h6 className="mb-0 ">Español</h6>
                                </div>
                              </div>
                            </Link>
                          </Card.Body>
                        </Card>
                      </Dropdown.Menu>
                    </Dropdown>
                  </div>
                  {/* <p>{t("sign_in_description")}</p> */}
                  {/* <Form className="mt-4 ">
                           <Form.Group className="form-group">
                              <Form.Label>{t('email_label')}</Form.Label>
                              <Form.Control type="email" className="mb-0" id="username" placeholder={t('email_placeholder')} value={formData.username} onChange={handleChange}/>
                           </Form.Group> */}
                  <Form className="mt-1">
                    {/* Toggle for email or mobile */}
                    <div
                      style={{
                        display: "flex",
                        justifyContent: "center",
                        alignItems: "center",
                      }}
                    >
                      <div
                        style={{
                          width: "200px",
                          height: "40px",
                          display: "flex",
                          justifyContent: useEmail ? "flex-start" : "flex-end",
                          alignItems: "center",
                          backgroundColor: "#007bff",
                          borderRadius: "50px",
                          padding: "5px",
                          cursor: "pointer",
                          transition: "0.3s",
                          boxShadow: "0 4px 8px rgba(0, 0, 0, 0.1)",
                        }}
                        onClick={() => setUseEmail((prev) => !prev)}
                      >
                        {/* Email */}
                        <div
                          style={{
                            width: "90px",
                            height: "30px",
                            backgroundColor: useEmail ? "#fff" : "transparent",
                            borderRadius: "40px",
                            display: "flex",
                            justifyContent: "center",
                            alignItems: "center",
                            color: useEmail ? "#007bff" : "#fff", // Blue for selected, white for unselected
                            fontWeight: "bold",
                            transition: "0.3s",
                          }}
                        >
                          {t('email_label')}
                        </div>

                        {/* Mobile */}
                        <div
                          style={{
                            width: "90px",
                            height: "30px",
                            backgroundColor: !useEmail ? "#fff" : "transparent",
                            borderRadius: "40px",
                            display: "flex",
                            justifyContent: "center",
                            alignItems: "center",
                            color: !useEmail ? "#007bff" : "#fff", // Blue for selected, white for unselected
                            fontWeight: "bold",
                            transition: "0.3s",
                          }}
                        >
                          {t('mobile')}
                        </div>
                      </div>
                    </div>

                    {/* Email or Phone Field */}
                    {useEmail ? (
                      <Form.Group className="form-group mt-1">
                        <Form.Label  className="required-label">{t('email_label')}</Form.Label>
                        <Form.Control
                          type="email"
                          id="email"
                          placeholder={t('email_placeholder')}
                          value={formData.email}
                          onChange={handleChange}
                          required
                        />
                      </Form.Group>
                    ) : (
                      <Form.Group className="form-group mt-1">
                        <Form.Label className="required-label">{t('mobile')}</Form.Label>
                        <PhoneInput
                          country={"in"}
                          value={formData.mobile}
                          onChange={handlePhoneChange}
                          inputStyle={{ width: "100%" }}
                          placeholder="Enter your phone number"
                          required
                        />
                      </Form.Group>
                    )}

                    {otpMode ? (
                      <Form.Group className="form-group">
                        <Form.Label className="required-label">{t("otp_label")}</Form.Label>
                        <Form.Control
                          type="number"
                          className="mb-0"
                          placeholder={t("otp_label")}
                          value={otp}
                          onChange={handleOtpChange}
                          required
                        />
                        <Link to="/auth/forgot" className="float-end">
                          {t("forgot_password")}
                        </Link>
                      </Form.Group>
                    ) : (
                      <Form.Group className="form-group">
                        <Form.Label className="required-label">{t("password_label")}</Form.Label>
                        <InputGroup>
                          <Form.Control
                            type={showLoginPassword ? "text" : "password"}
                            className="mb-0"
                            id="password"
                            placeholder={t("password_label")}
                            value={formData.password}
                            onChange={handleChange}
                            required
                          />

                          <Button
                            variant="link"
                            onClick={() => setShowLoginPassword(!showLoginPassword)}
                            className="eye-button"
                          >
                            {showLoginPassword ? <IoEyeOffOutline /> : <IoEyeOutline />}
                          </Button>
                        </InputGroup>
                        <Link to="/auth/forgot" className="float-end">
                          {t("forgot_password")}
                        </Link>
                      </Form.Group>
                    )}

                    <div className="d-inline-block w-100 mt-2">
                      <div className="">
                        <ReCAPTCHA
                          sitekey="6LeuawIrAAAAAFwff4haFoMqWAeIvybCT9vHRgkk"
                          onChange={handleCaptchaChange}
                        />
                      </div>
                    </div>
                    <div className="d-inline-block w-100 ">
                      <Form.Check className="d-inline-block mt-2 pt-1">
                        <Form.Check.Input
                          type="checkbox"
                          className="me-2"
                          id="customCheck11"
                          onChange={(e) => setRememberMe(e.target.checked)}
                          defaultChecked
                        />
                        <Form.Check.Label style={{ whiteSpace: "nowrap" }}>
                          {t("remember_me")}
                        </Form.Check.Label>{" "}
                      </Form.Check>
                      {otpMode ? (
                        <Button
                          variant="primary"
                          type="button"
                          className="float-end"
                          onClick={handleVerifyOtp}
                        >
                          {t("verify_otp_button")}
                        </Button>
                      ) : (
                        <Button
                          variant="primary"
                          type="button"
                          className="float-end"
                          onClick={handleLogin}
                        >
                          {t("sign_in_button")}
                        </Button>
                      )}
                    </div>
                    <div className="sign-info" style={{ marginTop: "10px" }}>
                      <span className="dark-color d-inline-block line-height-2">
                        {t("no_account_text")}{" "}
                        <Link to="/auth/sign-up">{t("sign_up_link")}</Link>
                      </span>
                      <ul className="iq-social-media">
                        <li>
                          <button
                            type="button"
                            onClick={handleMicrosoftLogin}
                            style={{
                              background: "none",
                              border: "none",
                              padding: 0,
                              cursor: "pointer",
                            }}
                          >
                            <svg
                              xmlns="http://www.w3.org/2000/svg"
                              width="22"
                              viewBox="0 0 48 48"
                            >
                              <title>{t("social_login_microsoft")}</title>
                              <rect x="4" y="4" width="18" height="18" fill="#F25022" />
                              <rect x="26" y="4" width="18" height="18" fill="#7FBA00" />
                              <rect x="4" y="26" width="18" height="18" fill="#00A4EF" />
                              <rect x="26" y="26" width="18" height="18" fill="#FFB900" />
                            </svg>

                          </button>
                        </li>

                        <li>
                          <button
                            type="button"
                            onClick={linkedInLogin}
                            style={{
                              background: "none",
                              border: "none",
                              padding: 0,
                              cursor: "pointer",
                            }}
                          >
                            {/* <SiLinkedin size={26}/> */}
                            <svg
                              xmlns="http://www.w3.org/2000/svg"
                              width="22"
                              height="22"
                              viewBox="0 0 48 48"
                            >
                              <title>{t("social_login_linkedin")}</title>
                              <rect width="48" height="48" fill="#0A66C2" />
                              <rect x="11" y="14" width="6" height="6" fill="#FFFFFF" />
                              <rect x="11" y="22" width="6" height="18" fill="#FFFFFF" />


                              <path
                                fill="#FFFFFF"
                                d="
      M22 22
      h6
      v2.4
      c1.1-1.9 3.1-3.2 6.1-3.2
      6.5 0 7.9 4.2 7.9 9.7
      v9.1
      h-6
      v-8
      c0-3.2-.1-5.6-3.4-5.6
      -3.4 0-4 2.7-4 5.4
      v8.2
      h-6
      V22
      z
    "
                              />
                            </svg>
                          </button>
                        </li>
                        <li>
                          <button
                            type="button"
                            onClick={() => handleGoogleLogin()}
                            style={{
                              background: "none",
                              border: "none",
                              padding: 0,
                              cursor: "pointer",
                            }}
                          >
                            <FcGoogle size={26} title={t("social_login_google")} />
                            {/* <svg
                              version="1.1"
                              xmlns="http://www.w3.org/2000/svg"
                              width="18"
                              viewBox="0 0 24 24"
                              fill="currentColor"
                            >
                              <title>{t("social_login_google")}</title>
                              <path d="M21.35 11.1h-9.42v2.82h5.83c-.33 1.67-1.67 2.99-3.4 3.46v2.9h5.49c3.21-2.97 3.82-8.26 1.5-12.18zM12 4.37c1.12 0 2.14.39 2.94 1.14l2.13-2.1c-1.61-1.5-3.7-2.35-6.07-2.35-4.68 0-8.55 3.8-8.55 8.5s3.87 8.5 8.55 8.5c3.83 0 7.05-2.56 8.08-6h-8.08v-2.82h13.32v2.82c.01.14.01.28.01.42 0 6.29-5.1 11.4-11.4 11.4s-11.4-5.1-11.4-11.4c0-6.3 5.1-11.4 11.4-11.4z"></path>
                              <path fill="#EA4335" d="M24 9.5c3.2 0 5.3 1.3 6.5 2.4l4.8-4.8C32.4 4.4 28.6 2.5 24 2.5 14.8 2.5 7.2 8.7 4.7 17.2l5.7 4.4C12.2 14.5 17.7 9.5 24 9.5z"/>
  <path fill="#4285F4" d="M46.1 24.5c0-1.5-.1-2.6-.4-3.8H24v7.2h12.7c-.5 3-2.2 5.5-4.8 7.2l5.8 4.5c3.4-3.2 5.4-7.9 5.4-15.1z"/>
  <path fill="#FBBC05" d="M10.4 28.2c-.5-1.4-.8-2.9-.8-4.5s.3-3.1.8-4.5l-5.7-4.4C2.9 17.5 2 20.6 2 23.7s.9 6.2 2.7 8.9l5.7-4.4z"/>
  <path fill="#34A853" d="M24 45.5c4.6 0 8.4-1.5 11.2-4.1l-5.8-4.5c-1.6 1.1-3.7 1.9-5.4 1.9-6.3 0-11.8-5-13.6-11.6l-5.7 4.4C7.2 39.3 14.8 45.5 24 45.5z"/>
                            </svg> */}
                          </button>
                        </li>
                        <li>
                          <button
                            type="button"
                            onClick={() => handleAppleLogin()}
                            style={{
                              background: "none",
                              border: "none",
                              padding: 0,
                              cursor: "pointer",
                            }}
                          >
                            {/* Apple icon added by Prince*/}
                            <DiApple title={t("social_login_apple")} size={26} />
                            {/* <svg
                              version="1.1"
                              xmlns="http://www.w3.org/2000/svg"
                              width="18"
                              viewBox="0 0 24 24"
                              fill="currentColor"
                            >
                              <title>{t("social_login_apple")}</title>
                              <path d="M16.365 1.43c0 1.14-.416 2.087-1.247 2.87-.83.79-1.827 1.257-2.99 1.257-.1-1.12.368-2.113 1.25-2.918.93-.89 2.04-1.327 3.24-1.21a.206.206 0 0 1-.253.001zm5.035 17.407c-.17.434-.53 1.054-1.088 1.855-.76 1.082-1.396 1.93-1.91 2.553-.643.77-1.31 1.167-2.002 1.189-.51 0-1.12-.15-1.83-.446-.71-.295-1.36-.447-1.95-.447-.63 0-1.3.15-2 .447-.72.297-1.33.451-1.82.461-.67.02-1.36-.37-2.07-1.168-.53-.628-1.18-1.513-1.95-2.553-.88-1.204-1.54-2.456-1.97-3.752-.43-1.32-.63-2.592-.6-3.818.06-1.33.37-2.448.92-3.35a5.49 5.49 0 0 1 2.25-2.2 6.263 6.263 0 0 1 3.01-.79c.51 0 1.18.17 2.01.52.83.34 1.35.52 1.57.52.18 0 .77-.2 1.77-.52.97-.34 1.79-.51 2.47-.51a6.116 6.116 0 0 1 3.01.8c.9.53 1.6 1.25 2.09 2.14-1.36.84-2.04 2.05-2.04 3.62.02 1.07.32 2.03.91 2.88.63.92 1.47 1.57 2.52 1.88-.2.58-.41 1.12-.64 1.62z"></path>
                            </svg> */}
                          </button>
                        </li>
                      </ul>
                    </div>
                  </Form>
                </div>
              </Col>
            </Row>
          </Container>
        </section>
        <Footer />
      </div>
    </>
  );
};

const styles = {
  loaderOverlay: {
    position: "fixed",
    top: 0,
    left: 0,
    width: "100%",
    height: "100%",
    backgroundColor: "rgba(0, 0, 0, 0.6)",
    display: "flex",
    justifyContent: "center",
    alignItems: "center",
    zIndex: 9999,
  },
};

export default SignIn;
